import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState, mapActions } from 'vuex';
import util from '@/libs/util';
import editPassword from "@/components/editPassword";
export default {
  components: {
    editPassword: editPassword
  },
  data: function data() {
    return {
      info: JSON.parse(util.cookies.get('userInfo')),
      isShowEditPassword: false
    };
  },
  // computed: {
  //   ...mapState('d2admin/user', [
  //     'info'
  //   ])
  // },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/account', ['logout'])), {}, {
    handelDialogSubmit: function handelDialogSubmit() {},
    closeEditPssword: function closeEditPssword() {
      this.isShowEditPassword = false;
    },
    openEditPassword: function openEditPassword() {
      this.isShowEditPassword = true;
    },

    /**
     * @description 登出
     */
    logOff: function logOff() {
      this.logout({
        confirm: true
      });
    }
  })
};